import { DatePicker, DatePickerProps } from '@conexasaude/conexa-hero'
import { ChangeEvent, ReactElement } from 'react'
import {
  Controller,
  Control,
  Path,
  ControllerRenderProps,
  ControllerFieldState,
  UseFormStateReturn,
} from 'react-hook-form'

type DatePickerControlType<T> = DatePickerProps & {
  name: Path<T>
  control?: Control<T>
}

export function DatePickerControl<T>({
  name,
  control,
  onChange: onInputChange,
  ...rest
}: DatePickerControlType<T>): ReactElement {
  function handleControllerRender({
    field,
  }: {
    field: ControllerRenderProps<T, Path<T>>
    fieldState: ControllerFieldState
    formState: UseFormStateReturn<T>
  }) {
    return (
      <DatePicker
        onChange={event => {
          field.onChange(event as unknown as ChangeEvent<Element>)
          if (onInputChange) onInputChange(event)
        }}
        value={field.value ? (field.value as Date) : null}
        ref={field.ref}
        {...rest}
      />
    )
  }

  return (
    <Controller name={name} control={control} render={handleControllerRender} />
  )
}

export default DatePickerControl
